import React from 'react';
import PropTypes from 'prop-types';
import OperatorAvatar from '../../../OperatorAvatar';

const ModalOperatorItem = ({
  operatorId,
  imageUrl,
  fullName,
  onOperatorSelect,
  hasChecked,
}) => {
  return (
    <div
      className={`modal__container__body__agents__list__agent ${hasChecked} flex flex-column flex-ai-c`}
      onClick={onOperatorSelect}
    >
      <div className='modal__container__body__agents__list__agent__img grid grid-pi-c'>
        <OperatorAvatar
          avatarId={operatorId}
          imageUrl={imageUrl}
          fullName={fullName}
          wrapperClass='asignOperator'
        />
        <label className='modal__container__body__agents__list__agent__img__checkbox'></label>
      </div>
      <div className='modal__container__body__agents__list__name'>
        {fullName}
      </div>
    </div>
  );
};

ModalOperatorItem.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  onOperatorSelect: PropTypes.func.isRequired,
  hasChecked: PropTypes.string.isRequired,
};

export default ModalOperatorItem;
